<template>
  <label :class="{ 'field__container--error': error }" class="field__container">
    <input :id="fieldId" v-model="value" class="field__input" type="checkbox" />

    <p class="field__label">
      <slot />
    </p>
  </label>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    error?: boolean;
    fieldId: string;
  }>(),
  {
    error: false,
  },
);
const value = defineModel<boolean>();
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixins";

.field__container {
  @apply grid;
  grid-template-columns: theme("width.10") 1fr;

  .field__input {
    @apply relative w-10 h-10 appearance-none border-primary-100 bg-primary-75 cursor-pointer;
    border-width: 1px;
    border-radius: 0.8rem;
    transition: 0.4s;

    &::before {
      content: "";
      @apply absolute w-full h-full top-0 left-0 opacity-0;
      @include gradient();
      border-radius: inherit;
      transition: 0.4s;
    }

    &:checked::before {
      @apply opacity-100;
    }
  }

  .field__label {
    @apply flex items-center pl-4 text-primary-400 text-body-xxs cursor-pointer;
    transition: 0.4s;
    line-height: 2.24rem;
  }

  &--error {
    .field__input {
      @apply border-error-500;
    }

    .field__label {
      @apply text-error-500;
    }
  }
}
</style>
